import GraphqlClient from './GraphqlClients';
import gql from 'graphql-tag';

export const registeredParsersQuery = gql`
  query RegisteredParsers($country: String) {
    parsers: parser_registeredParsers(country: $country) {
      documentType
      infoProvider
      formatType
    }
  }
`;

export const parserVersionsQuery = gql`
  query ParserVersions($documentType: String!, $infoProvider: String!, $formatType: String) {
    versions: parser_parserVersions(
      documentType: $documentType
      infoProvider: $infoProvider
      formatType: $formatType
    ) {
      id
      version
      validFrom
      validTo
    }
  }
`;

// The gateway caps the listed items at this limit; `count` always reports the full total.
export const BULK_REPARSE_CANDIDATES_LIMIT = 1000;

export const bulkReparseCandidatesQuery = gql`
  query BulkReparseCandidates($filter: parser_BulkReparseFilterInput!, $limit: Int) {
    candidates: parser_bulkReparseCandidates(filter: $filter, limit: $limit) {
      count
      truncated
      items {
        parsingJobId
        scrapedDocumentId
        documentName
        date
      }
    }
  }
`;
export const bulkReparseJobQuery = gql`
  query BulkReparseJob($id: String!) {
    job: parser_bulkReparseJob(id: $id) {
      id
      status
      totalCount
      processedCount
      succeededCount
      failedCount
      createdBy
      createdAt
      updatedAt
    }
  }
`;

const BulkReparseService = () => {
  const gqlClient = GraphqlClient();

  const bulkReparseMutation = gql`
    mutation BulkReparse($filter: parser_BulkReparseFilterInput!, $createdBy: String) {
      operation: parser_bulkReparse(filter: $filter, createdBy: $createdBy) {
        bulkReparseJob {
          id
          status
        }
      }
    }
  `;

  const getParserVersions = (documentType, infoProvider, formatType = 'default') =>
    gqlClient
      .query({
        query: parserVersionsQuery,
        variables: { documentType, infoProvider, formatType },
        fetchPolicy: 'network-only'
      })
      .then((data) => data.data.versions || []);

  const bulkReparse = (filter, createdBy) =>
    gqlClient
      .mutate({ mutation: bulkReparseMutation, variables: { filter, createdBy } })
      .then((data) => data.data.operation.bulkReparseJob);

  const getBulkReparseJob = (id) =>
    gqlClient
      .query({ query: bulkReparseJobQuery, variables: { id }, fetchPolicy: 'network-only' })
      .then((data) => data.data.job)
      .catch(() => null);

  return {
    getParserVersions,
    bulkReparse,
    getBulkReparseJob
  };
};

export default BulkReparseService;
